import { combineReducers } from "redux";
import Mainreducer from "./Mainreducer";


export default combineReducers({
   Mainreducer
})
